(function () {
  'use strict';

  if (window.__efaCtaMagneticV1) return;
  window.__efaCtaMagneticV1 = true;

  var SELECTOR = '.efa-cta--v5.efa-cta--magnetique';
  var AMPLITUDE_X = 5;
  var AMPLITUDE_Y = 3;
  var SMOOTHING = 18;
  var SETTLE_EPSILON = 0.02;
  var finePointer = window.matchMedia('(pointer: fine)');
  var hoverPointer = window.matchMedia('(hover: hover)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var passive = { passive: true };
  var passiveCapture = { passive: true, capture: true };

  var current = null;
  var pointerId = null;
  var rect = null;
  var positionX = 0;
  var positionY = 0;
  var targetX = 0;
  var targetY = 0;
  var frame = 0;
  var lastTime = 0;
  var tracking = false;

  function closestMagnetic(target) {
    if (!target || target.nodeType !== 1 || !target.closest) return null;
    return target.closest(SELECTOR);
  }

  function clamp(value) {
    return Math.max(-1, Math.min(1, value));
  }

  function canTrack(event) {
    return finePointer.matches &&
      hoverPointer.matches &&
      !reducedMotion.matches &&
      event.pointerType === 'mouse' &&
      event.isPrimary !== false;
  }

  function setTarget(clientX, clientY) {
    if (!rect || !rect.width || !rect.height) return;
    targetX = clamp((clientX - (rect.left + rect.width / 2)) / (rect.width / 2)) * AMPLITUDE_X;
    targetY = clamp((clientY - (rect.top + rect.height / 2)) / (rect.height / 2)) * AMPLITUDE_Y;
  }

  function isInsideReference(clientX, clientY) {
    return !!rect && clientX >= rect.left && clientX <= rect.right &&
      clientY >= rect.top && clientY <= rect.bottom;
  }

  function removeTemporaryListeners() {
    document.removeEventListener('pointermove', onPointerMove, passive);
    document.removeEventListener('pointercancel', onPointerCancel, passive);
    window.removeEventListener('scroll', onViewportChange, passiveCapture);
    window.removeEventListener('resize', onViewportChange, passive);
  }

  function clearCurrent() {
    if (frame) window.cancelAnimationFrame(frame);
    frame = 0;
    lastTime = 0;
    removeTemporaryListeners();

    if (current) {
      current.style.removeProperty('--efa-cta-magnet-x');
      current.style.removeProperty('--efa-cta-magnet-y');
      current.removeAttribute('data-efa-magnet');
    }

    current = null;
    pointerId = null;
    rect = null;
    positionX = 0;
    positionY = 0;
    targetX = 0;
    targetY = 0;
    tracking = false;
  }

  function requestTick() {
    if (frame || !current) return;
    lastTime = 0;
    frame = window.requestAnimationFrame(tick);
  }

  function tick(timestamp) {
    var delta = lastTime ? Math.min((timestamp - lastTime) / 1000, 0.05) : 1 / 60;
    var alpha = 1 - Math.exp(-SMOOTHING * delta);
    var settled;

    frame = 0;
    lastTime = timestamp;
    if (!current) return;

    positionX += (targetX - positionX) * alpha;
    positionY += (targetY - positionY) * alpha;
    settled = Math.abs(targetX - positionX) < SETTLE_EPSILON &&
      Math.abs(targetY - positionY) < SETTLE_EPSILON;

    if (settled) {
      positionX = targetX;
      positionY = targetY;
    }

    current.style.setProperty('--efa-cta-magnet-x', positionX.toFixed(3) + 'px');
    current.style.setProperty('--efa-cta-magnet-y', positionY.toFixed(3) + 'px');

    if (!tracking && settled) {
      clearCurrent();
      return;
    }

    if (!settled) frame = window.requestAnimationFrame(tick);
  }

  function addTemporaryListeners() {
    document.addEventListener('pointermove', onPointerMove, passive);
    document.addEventListener('pointercancel', onPointerCancel, passive);
    window.addEventListener('scroll', onViewportChange, passiveCapture);
    window.addEventListener('resize', onViewportChange, passive);
  }

  function activate(element, event) {
    if (current && current !== element) clearCurrent();

    if (!current) {
      current = element;
      pointerId = event.pointerId;
      rect = element.getBoundingClientRect();
      positionX = 0;
      positionY = 0;
      tracking = true;
      current.setAttribute('data-efa-magnet', 'active');
      addTemporaryListeners();
    } else if (!tracking) {
      /* Une réentrée pendant le retour reprend la position courante : pas de
         saut au centre, et pas de second moteur. */
      pointerId = event.pointerId;
      tracking = true;
      current.setAttribute('data-efa-magnet', 'active');
      addTemporaryListeners();
    }

    setTarget(event.clientX, event.clientY);
    requestTick();
  }

  function beginReturn() {
    if (!current || !tracking) return;
    removeTemporaryListeners();
    tracking = false;
    targetX = 0;
    targetY = 0;
    current.setAttribute('data-efa-magnet', 'return');
    requestTick();
  }

  function onPointerOver(event) {
    var element = closestMagnetic(event.target);
    if (!element || !canTrack(event)) return;
    activate(element, event);
  }

  function onPointerOut(event) {
    if (!current || event.pointerId !== pointerId) return;
    /* La boîte de référence ne bouge pas avec le CTA. Un pointerout provoqué
       par la translation elle-même ne termine donc pas prématurément l’effet. */
    if (isInsideReference(event.clientX, event.clientY)) return;
    beginReturn();
  }

  function onPointerMove(event) {
    if (!current || !tracking || event.pointerId !== pointerId || !canTrack(event)) return;
    if (!isInsideReference(event.clientX, event.clientY)) {
      beginReturn();
      return;
    }
    setTarget(event.clientX, event.clientY);
    requestTick();
  }

  function onPointerCancel(event) {
    if (current && event.pointerId === pointerId) clearCurrent();
  }

  function onViewportChange() {
    /* Le rectangle de référence est volontairement lu une seule fois. Si la
       mise en page bouge, on nettoie plutôt que de poursuivre avec une boîte
       devenue obsolète. */
    clearCurrent();
  }

  function onFocusIn(event) {
    if (current && current.contains(event.target)) clearCurrent();
  }

  function onVisibilityChange() {
    if (document.hidden) clearCurrent();
  }

  function onMediaChange() {
    if (!finePointer.matches || !hoverPointer.matches || reducedMotion.matches) clearCurrent();
  }

  function onSectionUnload(event) {
    if (current && event.target && event.target.contains(current)) clearCurrent();
  }

  /* EF 2026-08-24 (EXEC WG15, spec H4) : sortie anticipee mobile. Les gardes pointer:fine /
     hover:hover vivaient DANS les handlers : 10 ecouteurs restaient attaches sur un environnement
     tactile ou l effet ne peut pas se declencher (AUDIT_CTA_MOBILE 24/08, C.3). Desormais rien ne
     s attache tant que (hover: hover) et (pointer: fine) ne matchent pas ; un ecouteur change sur
     chaque MediaQueryList initialise si l environnement devient souris. reduced-motion reste gere
     a l execution (canTrack / onMediaChange), comme avant. Desktop : comportement identique.
     Revert : remplacer ce bloc par l attachement inconditionnel d origine. */
  var listenersAttached = false;

  function attachListeners() {
    if (listenersAttached) return;
    listenersAttached = true;
    document.addEventListener('pointerover', onPointerOver, passive);
    document.addEventListener('pointerout', onPointerOut, passive);
    document.addEventListener('focusin', onFocusIn);
    document.addEventListener('visibilitychange', onVisibilityChange);
    document.addEventListener('shopify:section:unload', onSectionUnload);
    window.addEventListener('blur', clearCurrent);

    if (finePointer.addEventListener) {
      finePointer.addEventListener('change', onMediaChange);
      hoverPointer.addEventListener('change', onMediaChange);
      reducedMotion.addEventListener('change', onMediaChange);
    } else {
      finePointer.addListener(onMediaChange);
      hoverPointer.addListener(onMediaChange);
      reducedMotion.addListener(onMediaChange);
    }
  }

  function attachWhenPointerEnvironmentAllows() {
    if (finePointer.matches && hoverPointer.matches) {
      attachListeners();
      return;
    }
    var onEnvironmentChange = function () {
      if (finePointer.matches && hoverPointer.matches) attachListeners();
    };
    if (finePointer.addEventListener) {
      finePointer.addEventListener('change', onEnvironmentChange);
      hoverPointer.addEventListener('change', onEnvironmentChange);
    } else {
      finePointer.addListener(onEnvironmentChange);
      hoverPointer.addListener(onEnvironmentChange);
    }
  }

  attachWhenPointerEnvironmentAllows();
}());
